import { getCurrencyCode, Language } from '@/utilities/language';

interface CurrencyDetails {
  amount_decimal: number;
  amount_int: number;
  currency: string;
  precision: number;
}

export const CurrencyCode = {
  CZK: 'czk',
  EUR: 'eur',
} as const;

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode];

export type CurrencyCollection = {
  [key in CurrencyCode]: CurrencyDetails;
};

export class Price {
  private data: CurrencyCollection;

  constructor(data: CurrencyCollection) {
    this.data = data;
  }

  /**
   * Retrieves currency details for a given code, which can be a Language or a CurrencyCode.
   * @param code The Language or CurrencyCode to get details for.
   * @returns The CurrencyDetails object or undefined if not found.
   */
  public getCurrencyDetails(
    code: CurrencyCode | Language,
  ): CurrencyDetails | undefined {
    // Determine the final CurrencyCode based on the input type
    let currencyCode: CurrencyCode;
    if (Object.values(Language).includes(code as Language)) {
      currencyCode = getCurrencyCode(code as Language);
    } else {
      currencyCode = code as CurrencyCode;
    }

    return this.data[currencyCode];
  }
}
